import { useTranslation } from 'react-i18next';

import { DateVehicleEmptyActions } from '@/shared/ui/no-result-display/DateVehicleEmptyActions';
import DisplayNoResult from '@/shared/ui/no-result-display/DisplayNoResult';

export function RoutesNoResult({
  onChooseNewDate,
  onChooseNewVehicle,
  targetName,
}: {
  onChooseNewDate: () => void;
  onChooseNewVehicle: () => void;
  targetName: string;
}) {
  const { t } = useTranslation();

  return (
    <DisplayNoResult message={t('routes.noResult', { suffix: t('routes.noResultSuffix', { vesselName: targetName }) })}>
      <DateVehicleEmptyActions
        onChooseNewDate={onChooseNewDate}
        onChooseNewVehicle={onChooseNewVehicle}
        newDateLabel={t('general.setNewDate')}
        newVehicleLabel={t('general.setNewVehicle')}
      />
    </DisplayNoResult>
  );
}
